import { QuestionFragment } from "@gql-schema";
import { SectionRenderer } from "@shared/components/section-renderer/section-renderer";
import { SectionLayout } from "@ui/components/section-layout/section-layout";
import { cx } from "@uxf/core/utils/cx";
import { useTranslation } from "next-i18next";
import React, { FC } from "react";

export const FaqQuestionPageSection: FC<QuestionFragment> = ({ answer, content, question }) => {
    const { t } = useTranslation();

    return (
        <div className="bg-uxfVioletLightest">
            <div className="ui-container flex">
                <SectionLayout name={t("faq")} title={question} isPage>
                    <p
                        className={cx(
                            "ui-typo-medium text-uxfMuted75",
                            content.sections?.length > 0 && "mb-12 md:mb-20 lg:mb-28",
                        )}
                    >
                        {answer}
                    </p>
                    <SectionRenderer sections={content.data} />
                </SectionLayout>
            </div>
        </div>
    );
};
